import { createActionsHook, createStateHook, createStore } from 'react-sweet-state';
var initialState = {
  activeSpotlight: null
};
var actions = {
  start: function start() {
    return function (_ref) {
      var setState = _ref.setState;
      setState({
        activeSpotlight: 0
      });
    };
  },
  next: function next() {
    return function (_ref2) {
      var setState = _ref2.setState,
        getState = _ref2.getState;
      setState({
        activeSpotlight: (getState().activeSpotlight || 0) + 1
      });
    };
  },
  end: function end() {
    return function (_ref3) {
      var setState = _ref3.setState;
      setState({
        activeSpotlight: null
      });
    };
  }
};
var ConversationAssistantSpotlightStore = createStore({
  initialState: initialState,
  actions: actions,
  name: 'ConversationAssistantSpotlightStore'
});
export var useConversationAssistantSpotlightActions = createActionsHook(ConversationAssistantSpotlightStore);
export var useConversationAssistantSpotlightState = createStateHook(ConversationAssistantSpotlightStore);